import {
  InvoiceIntegrationSearchRequest,
  InvoiceIntegrationAppListSearchRequest,
  InvoiceIntegrationAppConfigRequest,
} from '@trukt/tms-api/InvoiceIntegrationService';
import { createKey } from './createKey';

const keyHandler = createKey('invoice-integration');

export const InvoiceIntegrationServiceKeys = {
  key: keyHandler.key,
  search: keyHandler.createMethod<InvoiceIntegrationSearchRequest>(),
  searchAppList: keyHandler.createMethod<InvoiceIntegrationAppListSearchRequest>(),
  getAppConfigs: keyHandler.createMethod<InvoiceIntegrationAppConfigRequest>(),
};
